// src/pages/LoginPage/LoginPage.tsx
import { ChangeEvent, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
// import { Box, Button, Stack, TextField } from '@mui/material';
import { observer } from "mobx-react";
import styles from "./styles.module.scss";
import { authStore } from "stores";
import { RouterPathEnum } from "shared/enums/commonEnums";
import { Button } from "../../components/frontComponents/button/Button";
import "./LoginPage.scss";
import PhotoLost from "../../assets/images/login/photoLost.png";
import PhotoLogin from "../../assets/images/login/photoLogin.png";
import PhotoFirst from "../../assets/images/login/photoFirst.png";
// import BubbleLogin from "../../assets/images/login/bubleLogin.png";
import { NotScrollJournalPage } from "components/frontComponents/notScrollJournalPage/NotScrollJournalPage";
import PhotoLost1440 from "../../assets/images/login/photoLost1440.png";
import PhotoLogin1440 from "../../assets/images/login/photoLogin1440.png";

import BubbleLogin1440 from "../../assets/images/login/bubleLogin1440.png";
import Error from "../../assets/images/login/error.png";
import { LuEyeClosed } from "react-icons/lu";
import { LuEye } from "react-icons/lu";

const LoginPage = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [showPassword, setShowPassword] = useState<boolean>(false);

  const EyeClosedIcon = LuEyeClosed as any;
  const EyeIcon = LuEye as any;

  useEffect(() => {
    if (error) {
      const timer = setTimeout(() => {
        setError(null);
      }, 2000);

      return () => clearTimeout(timer);
    }
  }, [error]);

  const authorize = async () => {
    // await authStore.signIn();
    // if (authStore.currentUser) navigate(RouterPathEnum.Profile);
    try {
      setLoading(true);
      setError(null);

      await authStore.signIn();

      if (authStore.currentUser) {
        navigate(RouterPathEnum.Profile);
      } else {
        setError("Не удалось получить данные пользователя");
      }
    } catch (err: any) {
      // Обработка различных типов ошибок
      const errorMessage = err.message || "Ошибка авторизации";
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  // const goToRegister = () => {
  //   navigate(RouterPathEnum.RegistrationPage);
  // };

  // const [HasValue, setHasValue] = useState(false);
  // const [HasValue2, setHasValue2] = useState(false);
  // const [HasValuePass, setHasValuePass] = useState(false);

  // const makeAnimationStartHandler =
  //   (stateSetter: { (value: SetStateAction<boolean>): void; (arg0: boolean): void }) =>
  //   (e: any) => {
  //     const autofilled = !!e.target?.matches('*:-webkit-autofill');
  //     if (e.target.value != false) {
  //       setHasValue2(true);
  //       stateSetter(autofilled);
  //     }
  //     if (e.animationName === 'mui-auto-fill') stateSetter(autofilled);
  //     if (e.animationName === 'mui-auto-fill-cancel') stateSetter(autofilled);
  //   };

  const onChangeUsername = (event: ChangeEvent<HTMLInputElement>) => {
    authStore.setUsername(event.target.value);
    // setHasValue2(!!event.target.value);
  };

  const onChangePassword = (event: ChangeEvent<HTMLInputElement>) => {
    authStore.setPassword(event.target.value);
    // setHasValuePass(!!event.target.value);
  };

  return (
    // <Box className={cnLoginPage.toString()}>
    //   <Loader visible={authStore.isLoading} />

    //   <Stack
    //     component="form"
    //     onSubmit={(e) => {
    //       e.preventDefault();
    //       authorize();
    //     }}
    //     className={cnLoginPage('form').toString()}
    //     direction="column"
    //     gap={3}
    //     padding={4}
    //     borderRadius={2}
    //     maxWidth={400}
    //     margin="auto"
    //   >
    //     <h2 style={{ textAlign: 'center' }}>Вход</h2>

    //     <TextField
    //       label="Имя пользователя"
    //       value={authStore.username}
    //       onChange={onChangeUsername}
    //       inputProps={{
    //         onAnimationStart: makeAnimationStartHandler(setHasValue),
    //         autoComplete: 'username', // ✅ добавлено
    //       }}
    //       InputLabelProps={{ shrink: HasValue2 || HasValue }}
    //       fullWidth
    //     />

    //     <TextField
    //       label="Пароль"
    //       type="password"
    //       value={authStore.password}
    //       onChange={onChangePassword}
    //       inputProps={{
    //         autoComplete: 'current-password', // ✅ добавлено
    //       }}
    //       InputLabelProps={{ shrink: HasValue2 || HasValue || HasValuePass }}
    //       fullWidth
    //     />

    //     {authStore.error && (
    //       <div className="err">
    //         Пользователь с такими данными не найден. Проверьте логин и пароль
    //       </div>
    //     )}

    //     <Stack direction="row" gap={2} justifyContent="space-between">
    //       <Button variant="contained" type="submit" fullWidth>
    //         Войти
    //       </Button>
    //       <Button variant="outlined" fullWidth onClick={goToRegister}>
    //         Регистрация
    //       </Button>
    //     </Stack>
    //   </Stack>
    // </Box>
    <section className={styles.section}>
      <div className={styles.login}>
        <NotScrollJournalPage
          leftContent={
            <div className={styles.loginLeft}>
              <div className={styles.loginPart}>
                <div className={styles.leftLeft}>
                  <div className={styles.loginholder}>
                    <div className={styles.enter}>
                      <div className={styles.titlePale}>
                        Доступ к мирам и достижениям
                      </div>
                      <form className={styles.formLogin}>
                        <div className={styles.labeledInput}>
                          <label className={styles.label}>
                            <div className={styles.inputlegend}>
                              Имя проводника
                            </div>
                            <div className={styles.inputfake}>
                              <input
                                className={styles.inputcontrol}
                                type="text"
                                name="username"
                                value={authStore.username}
                                onChange={onChangeUsername}
                                placeholder="Введите ваш позывной"
                              />
                            </div>
                          </label>
                        </div>
                        {error && (
                          <div className={styles.errorholder}>
                            <img
                              src={Error}
                              alt="error"
                              className={styles.error}
                            />
                          </div>
                        )}
                        <div className={styles.labeledInput}>
                          <label className={styles.label}>
                            <div className={styles.inputlegend}>
                              Эфирный ключ
                            </div>
                            <div className={styles.inputWrapper}>
                              <div className={styles.inputfake}>
                                <input
                                  className={styles.inputcontrol}
                                  type={showPassword ? "text" : "password"}
                                  name="password"
                                  value={authStore.password}
                                  onChange={onChangePassword}
                                  placeholder="Введите код доступа"
                                />
                              </div>{" "}
                              <button
                                type="button"
                                className={styles.passwordToggle}
                                onClick={() => setShowPassword(!showPassword)}
                                aria-label={
                                  showPassword
                                    ? "Скрыть пароль"
                                    : "Показать пароль"
                                }
                              >
                                {showPassword ? (
                                  <EyeIcon style={{ fontSize: "20px" }} />
                                ) : (
                                  <EyeClosedIcon style={{ fontSize: "20px" }} />
                                )}
                              </button>
                            </div>
                          </label>
                        </div>
                        <Button
                          viewVariant="secondary"
                          text="Войти в мир"
                          className={styles.buttonloggin}
                          onClick={authorize}
                        />
                      </form>
                    </div>
                    <div className={styles.lost}>
                      {/* <img src={PhotoLost} alt="login key lost" /> */}
                      <picture>
                        <source
                          media="(min-width: 1620px)"
                          srcSet={PhotoLost}
                        />
                        <img
                          src={PhotoLost1440}
                          className={styles.photo}
                          alt="login key lost"
                          loading="lazy"
                        />
                      </picture>
                      <div className={styles.textLost}>
                        <div className={styles.titleDark}>Потеряли ключ?</div>
                        <div className={styles.line} />
                        <Button
                          viewVariant="secondary"
                          text="призвать ключ заново"
                          className={styles.middle}
                          onClick={() => navigate(RouterPathEnum.KeyLost)}
                        />
                      </div>
                    </div>
                  </div>
                  {/* <img src={PhotoLogin} alt="login" /> */}
                  <picture>
                    <source media="(min-width: 1620px)" srcSet={PhotoLogin} />
                    <img
                      src={PhotoLogin1440}
                      className={styles.photo}
                      alt="login"
                      loading="lazy"
                    />
                  </picture>
                </div>
              </div>
            </div>
          }
          rightContent={
            <div className={styles.loginRight}>
              <div className={styles.rightLeft}>
                <div className={styles.registration}>
                  <div className={styles.titleRight}>Первое путешествие</div>
                  <div className={styles.lineRight} />
                  <Button
                    viewVariant="secondary"
                    text="инициировать подключение"
                    className={styles.middleRight}
                    onClick={() => navigate(RouterPathEnum.RegistrationPage)}
                  />
                </div>
                <div className={styles.firstTime}>
                  <h2 className={styles.titleRight}>Первый раз в межмирье?</h2>
                  <Button
                    viewVariant="secondary"
                    text="узнать больше"
                    className={styles.middleRight}
                    onClick={() => navigate(RouterPathEnum.RegistrationPage)}
                  />
                </div>

                <div className={styles.bubble}>
                  <img
                    src={BubbleLogin1440}
                    className={styles.bubbleimg}
                    alt=""
                    loading="lazy"
                  />
                </div>
              </div>
              <div className={styles.photoholder}>
                <img
                  src={PhotoFirst}
                  alt="first login"
                  className={styles.photo1}
                />
              </div>
            </div>
          }
        />
      </div>
    </section>
  );
};

export default observer(LoginPage);
